import { ConcreteEncodable } from "./ConcreteEncodable";

import { BenchmarkOrderRequestDataImplEncoder } from "../../encoder/BenchmarkOrderRequestDataImplEncoder";

import * as CubiqTS from "../../index";
import { BenchmarkOrderRequestData } from "../BenchmarkOrderRequestData";

export class BenchmarkOrderRequestDataImpl
  extends ConcreteEncodable
  implements BenchmarkOrderRequestData
{
  public static enType: string = "com.bcdfx.model.event.BenchmarkOrderRequestDataImpl";

  /*FID=1*/
  public externalClientReference: string;
  /*FID=2*/
  public clientCode: string;
  /*FID=3*/
  public accountCode: string;
  /*FID=4*/
  public fixedAmount: string;
  /*FID=5*/
  public clientIntent: CubiqTS.OrderIntent;
  /*FID=6*/
  public tenor: CubiqTS.Tenor;
  /*FID=7*/
  public product: CubiqTS.Product;
  /*FID=8*/
  public base: string;
  /*FID=9*/
  public nonBase: string;
  /*FID=10*/
  public fixedCcy: string;
  /*FID=11*/
  public comment: string;
  /*FID=12*/
  public comment2: string;
  /*FID=13*/
  public fixingCode: string;
  /*FID=14*/
  public fixingDate: CubiqTS.StandardDate | null = null;
  /*FID=15*/
  public benchmarkTime: CubiqTS.Time | null = null;
  /*FID=16*/
  public rateSource: string;
  /*FID=17*/
  public fixingDateTime: CubiqTS.moment.Moment | null = null;
  /*FID=18*/
  public fixingTimeZone: string;
  /*FID=19*/
  public onBehalfOfCode: string;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = BenchmarkOrderRequestDataImplEncoder.Instance;
    this.setEncodableType(BenchmarkOrderRequestDataImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "BenchmarkOrderRequestDataImpl[" +
      "externalClientReference=" +
      this.externalClientReference +
      "clientCode=" +
      this.clientCode +
      "accountCode=" +
      this.accountCode +
      "fixedAmount=" +
      this.fixedAmount +
      "clientIntent=" +
      this.clientIntent +
      "tenor=" +
      this.tenor +
      "product=" +
      this.product +
      "base=" +
      this.base +
      "nonBase=" +
      this.nonBase +
      "fixedCcy=" +
      this.fixedCcy +
      "comment=" +
      this.comment +
      "comment2=" +
      this.comment2 +
      "fixingCode=" +
      this.fixingCode +
      "fixingDate=" +
      this.fixingDate +
      "benchmarkTime=" +
      this.benchmarkTime +
      "rateSource=" +
      this.rateSource +
      "fixingDateTime=" +
      this.fixingDateTime +
      "fixingTimeZone=" +
      this.fixingTimeZone +
      "onBehalfOfCode=" +
      this.onBehalfOfCode +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
